
import {$, bool, datetime, ID, InputType, Schema} from 'simpli-web-sdk'
import DeliveryCanceledResponse from '@/model/response/DeliveryCanceledResponse'
import RenderNumber from '@/components/render/RenderNumber.vue'

export default (model: DeliveryCanceledResponse): Schema => ({

    idCarga : {
        content: model.carga && model.carga.idCargaPk,
    },

    nome: {
        content: model.motorista && model.motorista.nome,
    },

    cpfMotorista: {
        content: model.motorista && model.motorista.cpf,
    },

    nfCarga: {
        content: model.carga && model.carga.nroNotaFiscal,
    },

    nroCTE: {
        textContent:
            model.carga && model.carga.cargaInfo && model.carga.cargaInfo.nroCte ? model.carga.cargaInfo.nroCte : '',
    },

    nroCteAlt: {
        content:
            model.carga && model.carga.cargaInfo && model.carga.cargaInfo.nroCte ? model.carga.cargaInfo.nroCte : '',
        textContent: null,
        input: InputType.TEXT,
    },

    danfeCarga: {
        content: model.carga && model.carga.danfe,
    },

    dataCriacao: {
        content: model.carga && datetime(model.carga.dataCriacao),
    },

    data: {
        content: datetime(model.data),
        textContent: datetime(model.data),
        input: InputType.DATETIME,
    },

    justificativa: {
        content: model.justificativa,
    },

    manifesto: {
        content: model.manifesto,
    },
})
